import { PaymentActivationScreen } from '@/components/payments/payment-activation-screen';

export default function PaymentsActivatePage() {
  return <PaymentActivationScreen />;
}
